





























































  import Vue from 'vue';

  export default Vue.extend({
    props: {
      value: {
        type: Boolean,
      },
      label: {
        type: String,
        required: true,
      },
      hint: {
        type: String,
        default: null,
      },
      tooltip: {
        type: String,
        default: null,
      },
      required: {
        type: Boolean,
        default: false,
      },
      rules: {
        type: Array,
        default: () => [],
      },
      id: {
        type: String,
        default: "confirmFieldRadioGroup",
      },
    },
    data() {
      return {
        confirmed: this.value,
        dialog: false,
      };
    },
    watch: {
      confirmed(val) {
        this.$emit('input', val);
      },
    },
  });
